// extracted by mini-css-extract-plugin
export default {"dashed":"html_utils_dashed__IfUDB"};